<template src="./JobRegister.html"></template>

<script>
import mixins from "../../../../../../Mixins";
export default {
  mixins: [mixins],
    props: {
    systemId: {
      required: false,
    }
  },
  name: "user-register",
  data() {
    return {
      name: null,
      horario: null,
      descricao: '',
      status: null,
      url: '',
      invalidFields: {
        name: false,
        horario: false,
        descricao: '',
        status: false,
        url: false
      },
      specificFieldsMessage: {
        name: "Campo obrigatório",
        horario: "Campo obrigatório",
        descricao: "Campo obrigatório",
      },
      fieldsWarning: false,
      passwordType: "password",
      weakPassword: `A senha deve ter ao menos 8 caracteres, letras maiúsculas, minúsculas, 
        números e caractere especial (@!#$%).`,
    };
  },
  methods: {
    adminUserRegister() {
      const user = {
        email: this.email,
        name: this.name,
        type: "ADMIN",
        password: this.password,
      }
      this.axios.post(this.$store.state.filooServer + `user-register`, user,
        { headers: { Authorization: this.$session.get("bearer") } }
      )
      .then( response => { 
        if (response.status === 201) 
        this.showNotifySuccess("Sucesso", "Usuário registrado!", 5000)
        setTimeout(() => {
          this.$router.push("manage-permissions")
        }, 4500);
      })
      .catch( err => {
        console.log({location: "adminUserRegister", error: err}) 
        if (err.status === 412) this.showNotifyWarning("E-mail já cadastrado. Tente novamente como outro e-mail!", 5000)
        else this.showNotifyWarning( "Não foi possível criar um novo usuário. Tente novamente mais tarde!", 5000)
      })
    },
    validateFields() {
      let valid = true;
      if (this.testNullUndefinedEmpty(this.name)) {
        valid = false;
        this.invalidFields.name = true;
        this.specificFieldsMessage.name = "Campo obrigatório";
      } else if (!this.testFullName(this.name)) {
        this.invalidFields.name = true;
        this.specificFieldsMessage.name = "Insira o nome completo";
      }
      if (this.testNullUndefinedEmpty(this.email)) {
        valid = false;
        this.invalidFields.email = true;
        this.specificFieldsMessage.email = "Campo obrigatório";
      } else if (!this.validateEmail(this.email)) {
        valid = false;
        this.invalidFields.email = true;
        this.specificFieldsMessage.email = "E-mail inválido";
      }
      if (this.testNullUndefinedEmpty(this.password)) {
        valid = false;
        this.invalidFields.password = true;
        this.specificFieldsMessage.password = "Campo obrigatório";
      } else if (this.testPasswordStrength(this.password)) {
        valid = false;
        this.invalidFields.password = true;
        this.specificFieldsMessage.password = this.weakPassword;
      }
      if (this.testNullUndefinedEmpty(this.confirmPassword)) {
        valid = false;
        this.invalidFields.confirmPassword = true;
        this.specificFieldsMessage.confirmPassword = "Campo obrigatório";
      }
      if (this.password != this.confirmPassword) {
        valid = false;
        this.invalidFields.confirmPassword = true;
        this.specificFieldsMessage.confirmPassword = "A senha e a confirmação de senha não conferem";
      }
      const regex = /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (regex.test(this.password) == false && this.testNullUndefinedEmpty(this.password) == false) {
        valid = false;
        this.invalidFields.password = true;
        this.specificFieldsMessage.password = this.weakPassword;
      }
      if (valid === false) this.fieldsWarning = true;
      else this.adminUserRegister();
    },
    testPasswordStrength(password) {
      const regex = /(?=^.{8,}$)((?=.*\d)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
      if (password == "") return;
      if (regex.test(password)) {
        this.invalidFields.password = false;
      } else {
        this.specificFieldsMessage.password = this.weakPassword;
        this.invalidFields.password = true;
      }
    },
    passwordVisibility() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    back() {
      this.$router.push("/manage-jobs")
    },
  }
};
</script>

<style lang="scss" src="./JobRegister.scss">
</style>
